import { render, staticRenderFns } from "./ParcelaTab2ViaContent.vue?vue&type=template&id=3904208f&scoped=true"
import script from "./ParcelaTab2ViaContent.vue?vue&type=script&lang=js"
export * from "./ParcelaTab2ViaContent.vue?vue&type=script&lang=js"
import style0 from "./ParcelaTab2ViaContent.vue?vue&type=style&index=0&id=3904208f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3904208f",
  null
  
)

export default component.exports